import React from "react";

import _ from "underscore";
import analytics from "web/script/analytics/analytics";
import browser from "web/script/utils/browser";
import globals from "web/script/modules/globals";
import userProfiler from "web/script/modules/userprofiler";
import PropTypes from "prop-types";

function TrackedButton({
    href,
    openInNewTab,
    eventCategory,
    eventAction,
    eventLabel,
    children,
    productId,
    reason
}) {
    function onClick(event) {
        if (_.isString(eventCategory) && _.isString(eventAction) && href) {
            let newTab = (browser.mac && event.metaKey) || (!browser.mac && event.ctrlKey);
            if (openInNewTab || newTab) {
                analytics.event(eventCategory, eventAction, eventLabel);
            } else {
                event.preventDefault();
                analytics.event(eventCategory, eventAction, eventLabel).then(() => {
                    globals.window.location = href;
                });
            }
        }
        // Combining some of lead-link behaviour into tracked button
        if (productId) {
            userProfiler.saveClickedLead(productId, reason);
        }
    }

    return (
        <a href={href} onClick={onClick} target={openInNewTab ? "_blank" : null}>
            {children}
        </a>
    );
}

export default TrackedButton;

TrackedButton.propTypes = {
    href: PropTypes.string.isRequired,
    openInNewTab: PropTypes.bool,
    eventCategory: PropTypes.string.isRequired,
    eventAction: PropTypes.string.isRequired,
    eventLabel: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    productId: PropTypes.number,
    reason: PropTypes.string
};

TrackedButton.defaultProps = {
    openInNewTab: false
};
